module.exports = __webpack_public_path__ + "static/img/10.6e6bf04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/xxw/10.jpg
// module id = TzG8
// module chunks = 1